import React, { useState } from 'react';
import './SecurityFeatures.css';

const SecurityFeatures = () => {
  const [openFaq, setOpenFaq] = useState(null);

  const faqData = [
    {
      question: "¿Qué riesgos tiene compartir mi DNI?",
      answer: "Los riesgos de compartir tu DNI incluyen la posibilidad de que tu información personal sea utilizada de manera no autorizada o fraudulenta. Pixelando la cara, añadiendo una marca de agua o pasándola a blanco y negro disminuirá la posibilidad que tu DNI sea utilizado de manera no autorizada."
    },
    {
      question: "¿Es seguro usar esta aplicación?",
      answer: "Sí, esta aplicación es 100% segura y privada. Todos los datos se procesan localmente en tu dispositivo y no se envían a ningún servidor externo."
    },    
    {
      question: "En qué formato se genera el documento?",
      answer: "Obtendrás una imagen en formato JPG o en un documento PDF. Podrás descargarlo o compartirlo con WhatsApp, correo electrónico, etc"
    }
      
    
  ];

  const toggleFaq = (index) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  return (
    <div className="mb-0 py-2 mt-4" style={{ backgroundColor: '#393e46', color: '#f2f2f2' }}>      
      <div className="container p-4">
        <h2 className="mb-4 text-center">Preguntas Frecuentes</h2>
        <div className="row justify-content-center">
          <div className="col-10 col-lg-8">
            <ul className="list-unstyled">
              {faqData.map((faq, index) => (
                <li key={index} className="faq-item mb-2">
                  <div 
                    className="faq-question d-flex justify-content-between align-items-center p-3 rounded "
                    style={{ cursor: 'pointer', fontSize: '1.2rem', borderColor: '#222831', backgroundColor: '#222831' }}
                    onClick={() => toggleFaq(index)}
                  >
                    <span style={{ letterSpacing: '0.05em' }}>{faq.question}</span>
                    <span className="toggle-icon fs-4">
                      {openFaq === index ? '▲' : '▼'}
                    </span>
                  </div>
                  {openFaq === index && (
                    <div 
                      className="faq-answer p-3 border border-top-0 text-start text-dark"
                      style={{ fontSize: '1.1rem', borderColor: '#222831', backgroundColor: '#f2f2f2' }}
                    >
                      {faq.answer}
                    </div>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      
     
        <section className="container p-4 mt-2">
          <h2 className="mb-4 text-center">Artículos relacionados</h2>
          <div className="row">
            <div className="col-md-4 mb-3">
              <div className="card h-100" style={{ backgroundColor: '#222831', color: '#f2f2f2' }}>
                <div className="card-body">
                  <h5 className="card-title">
                    <a href="https://www.xataka.com/basics/como-compartir-tu-dni-internet-forma-segura-para-evitar-peligros" target="_blank" rel="noopener noreferrer" className="text-light text-decoration-none">Cómo compartir tu DNI en Internet de forma segura para evitar peligros</a>
                  </h5>
                  <p className="card-text small" style={{ color: '#a0a0a0' }}>
                    <span>Xataka</span> - 
                    <span className="ms-2">29 de mayo, 2023</span>
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-4 mb-3">
              <div className="card h-100" style={{ backgroundColor: '#222831', color: '#f2f2f2' }}>
                <div className="card-body">
                  <h5 className="card-title">
                    <a href="https://www.rtve.es/noticias/20240604/pixelar-datos-recomendaciones-expertos-compartir-dni-internet/16132816.shtml" target="_blank" rel="noopener noreferrer" className="text-light text-decoration-none">Pixelar datos y otras recomendaciones de los expertos para compartir el DNI por internet</a>
                  </h5>
                  <p className="card-text small" style={{ color: '#a0a0a0' }}>
                    <span>RTVE</span> - 
                    <span className="ms-2">4 de junio, 2024</span>
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-4 mb-3">
              <div className="card h-100" style={{ backgroundColor: '#222831', color: '#f2f2f2' }}>
                <div className="card-body">
                  <h5 className="card-title">
                    <a href="https://www.lavanguardia.com/andro4all/tecnologia/como-compartir-el-dni-en-internet-de-manera-segura" target="_blank" rel="noopener noreferrer" className="text-light text-decoration-none">Cómo compartir el DNI en Internet de manera segura</a>
                  </h5>
                  <p className="card-text small" style={{ color: '#a0a0a0' }}>
                    <span>La Vanguardia</span> - 
                    <span className="ms-2">24 de noviembre, 2023</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
  
      
    
    </div>
  );
};

export default SecurityFeatures;
